import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useNumFormatter } from '~/utils/format/num-formatter';
import { $CurrentAvailableDiscoverDataOrNull, $CurrentDiscoverStandardKeyword } from '@discover/shared/atom';
import _sumBy from 'lodash/sumBy';
import { loadable } from 'jotai/utils';

export const useDiscoverDescV2 = (): string => {
  const standardKeyword = useAtomValue($CurrentDiscoverStandardKeyword);
  const { t } = useTranslation();
  const formatNum = useNumFormatter();

  const loadableData = useAtomValue(loadable($CurrentAvailableDiscoverDataOrNull));

  if (loadableData.state !== 'hasData') {
    return '';
  }

  const data = loadableData.data;

  if (!data) {
    return '';
  }

  const totalDiggCount = _sumBy(data.article_v2.items, ({ article }) => article.diggCount);

  return t('seo_keyword_page_description')
    .replace('{keyword}', standardKeyword)
    .replace('%d', formatNum(totalDiggCount));
};
